/* eslint-disable react/prop-types */
import React from 'react';
import { formatSectionDateKey } from './helpers';
import PatientFileCard from './PatientFileCard';

const PatientFilesDateSection = ({
    dateKey,
    items,
    previewLoadingId,
    deletingId,
    onPreview,
    onDelete,
    canDelete,
}) => (
    <div className="patient-files__date-block">
        <p className="patient-files__date-heading">{formatSectionDateKey(dateKey)}</p>
        <div className="patient-files__cards">
            {items.map((doc) => (
                <PatientFileCard
                    key={doc._id}
                    doc={doc}
                    previewLoadingId={previewLoadingId}
                    deletingId={deletingId}
                    onPreview={onPreview}
                    onDelete={onDelete}
                    canDelete={canDelete}
                />
            ))}
        </div>
    </div>
);

export default PatientFilesDateSection;
